import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import ReactPaginate from 'react-paginate'
import Select from 'react-select'
import { ControlLabel, Form, FormGroup, FormControl, Row, Col, Button } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import HrStore from '../../../stores/HrStore'
import IframeModal from '../../../component/element/IframeModal'
import PrintButtons from 'component/element/PrintButtons'
// import withSizes from 'react-sizes';
import ReportMobileTable from '../../report/ReportMobileTable'
import EmployeeFilterTableSettingModal from '../EmployeeFilterTableSettingModal'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import {connect} from 'react-redux'
const localStorageKey = 'kkc.employee'
class ReportEmployee extends Component {

  constructor(...args) {
    super(...args)
    this.state = { 
      emStatus: 'work', 
      showFilter: false,
      loading: false, 
      emList: [], 
      itemPerPage: 20, 
      pageCount: 1,
      sort: JSON.parse(localStorage.getItem(localStorageKey)) || {sortStatus:'',sortStatus2:'',sortStatus3:'',sortStatus4:''},
      visible_fields:[]
    }
    this.refTableId = 'ReportEmployee-'+Math.ceil(Math.random()*100);
  }

  componentDidMount() {
    this.loadEmployee('work')
  }

  loadEmployee(emStatus) {
    let that = this
    let {sort} = this.state
    this.setState({ loading: true })
    HrStore.loadEmployee(emStatus, function (result) {
      let data = result.data
      if (sort.sortStatus===''&&sort.sortStatus2===''&&sort.sortStatus3===''&&sort.sortStatus4==='') {
        data = result.data
      } else {
        if (sort.sortStatus!=='') {
          if (sort.sortStatus===''||sort.sortStatus==='desc') {
            data.sort()
            data.reverse()
          } else if (sort.sortStatus==='asc') {
            data.sort()
          }
        } else if (sort.sortStatus2!=='') {
          if (sort.sortStatus2===''||sort.sortStatus2==='desc') {
            data.reverse(function(a, b) {
              if(a['first_name'] < b['first_name']) return -1;
              if(a['first_name'] > b['first_name']) return 1;
              return 0;
            })
          } else if (sort.sortStatus2==='asc') {
            data.sort(function(a, b) {
              if(a['first_name'] < b['first_name']) return -1;
              if(a['first_name'] > b['first_name']) return 1;
              return 0;
            })
          }
        } else if (sort.sortStatus3!=='') {
          if (sort.sortStatus3===''||sort.sortStatus3==='desc') {
            data.reverse(function(a, b) {
              if(a['last_name'] < b['last_name']) return -1;
              if(a['last_name'] > b['last_name']) return 1;
              return 0;
            })
          } else if (sort.sortStatus3==='asc') {
            data.sort(function(a, b) {
              if(a['last_name'] < b['last_name']) return -1;
              if(a['last_name'] > b['last_name']) return 1;
              return 0;
            })
          }
        } else if (sort.sortStatus4!=='') {
          if (sort.sortStatus4===''||sort.sortStatus4==='desc') {
            data.reverse(function(a, b) {
              if(a['nick_name'] < b['nick_name']) return -1;
              if(a['nick_name'] > b['nick_name']) return 1;
              return 0;
            })
          } else if (sort.sortStatus4==='asc') {
            data.sort(function(a, b) {
              if(a['nick_name'] < b['nick_name']) return -1;
              if(a['nick_name'] > b['nick_name']) return 1;
              return 0;
            })
          }
        }
      } 

      that.setState({ loading: false, emList: data, visible_fields:result.visible_fields })
    })
  }

  loadEmployeeQuery(query) {
    let that = this
    this.setState({ loading: true })
    HrStore.loadEmployeeQuery(query, function (result) {
      that.setState({ loading: false, emList: result.data })
    })
  }

  getEmStatusOptions() {
    let {messages} = this.props
    return ([{ value: '', label: '--- '+messages['Select All']+' ---' },
    { value: 'work', label: messages['All Active'] },
    { value: '0', label: messages['Full Time'] },
    { value: '1', label: messages['Sub Contract Monthly'] },
    { value: '2', label: messages['Sub Contract Daily'] },
    { value: '7', label: messages['Intern'] },
    { value: '8', label: messages['Contractor'] },
    { value: '3', label: messages['Exit'] },
    { value: '4', label: messages['Not Qualified'] },
    { value: '5', label: messages['Disappear'] },
    { value: '6', label: messages['Die'] }
    ])
  }

  getTitle(field) {
    let {messages} = this.props
    let title = ''
    title = (
      field==='employee_id'?messages['Employee Id']:field==='first_name'?messages['First Name']:field==='last_name'?messages['Last Name']:field==='nick_name'?messages['Nickname']
      :field==='mobile'?messages['Mobile']:field==='address_registration'?messages['Address Registration']:field==='current_address'?messages['Current Address']:field==='gender'?messages['gender']
      :field==='religion'?messages['Religion']:field==='race'?messages['Race']:field==='nationality'?messages['Nationality']:field==='height'?messages['Height']:field==='weight'?messages['Weight']
      :field==='marriage_status'?messages['Marriage Status']:field==='children'?messages['Children']:field==='dob_day'?messages['Birthday']:field==='dob_month'?messages['Birthday']:field==='dob_year'?messages['Birthday']
      :field==='id_card'?messages['Id Card']:field==='ssn'?messages['SSN']:field==='no_taxpayer'?messages['Taxpayer No']:field==='bank_name'?messages['Bank Name']:field==='bank_account'?messages['Bank Account']
      :field==='start_work_date'?messages['Start Work Date']:field==='permanance_work_date'?messages['Permanance Work Date']:field==='position'?messages['Position']:field==='department'?messages['Department']
      :field==='work_status'?messages['Work Status']:field==='slip_per_month'?messages['Slip Per Month']:field==='exit_date'?messages['Exit Date']:field==='exit_reason'?messages['Exit Reason']
      :field==='exit_remark'?messages['Exit Remark']:field==='net_saving'?messages['Net Saving']:field==='slip_by'?messages['Slip By']:field
    )
    return title
  }

  onEmStatusChange(e) {
    this.loadEmployee(e.value)

    this.setState({ emStatus: e.value })
  }

  onSearchKeyPress(target) {
    if (target.charCode == 13) {
      let { query } = this.state
      this.loadEmployeeQuery(query)
    }
  }

  onQueryChange(e) {
    this.setState({ query: e.target.value })
  }

  onSearchClick() {
    let { query } = this.state
    this.loadEmployeeQuery(query)
  }

  onPageChange(page) {
    // console.log('pageChagne', page)
  }

  onNewEmployeeClick() {
    if (process.env.NODE_ENV == "development") {
      alert('click new employee')
    } else {
      window.show_employee_doc('');
    }
  }

  onRowClick(emId) {
    if (process.env.NODE_ENV == "development") {
      alert('click employee ' + emId)
    } else {
      window.show_employee_doc(emId);
    }
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = this.props.messages['All Employee Report']+'.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintClick() {
    let url = ''
    let {emStatus,query} = this.state
    if (process.env.NODE_ENV == "development") {
      url = './?startPage=PrintReportEmployee&query='+(query==undefined?'':query)+'&status='+emStatus
    } else{
      url = './pdf/v2/?startPage=PrintReportEmployee&query='+(query==undefined?'':query)+'&status='+emStatus
    }
    this.refs.iframe.loadUrl(url) 
  }

  renderToolbar() {
    let { emStatus, query } = this.state
    let {isMobile,messages} = this.props
    return (
          <Form inline style={{marginBottom:'5px'}}>
            <FormGroup>
              <ControlLabel >{messages['Select Status']}</ControlLabel>
            </FormGroup>{' '}
            <FormGroup style={{width:(isMobile?'100%':'15%')}}>
              <Select
                value={emStatus}
                options={this.getEmStatusOptions()}
                clearable={false}
                onChange={this.onEmStatusChange.bind(this)} 
                style={{width:'100%'}}
              />
            </FormGroup>{' '}
            <FormGroup>
              <div className="input-group ">
                <FormControl
                  value={query}
                  placeholder={messages['Search Name']}
                  onKeyPress={this.onSearchKeyPress.bind(this)}
                  onChange={this.onQueryChange.bind(this)}
                  style={{width:'100%'}}
                />
                <span className="input-group-btn">
                  <Button className='btn-flat' onClick={this.onSearchClick.bind(this)}><FontAwesome name='search' /></Button>
                </span>
              </div>
            </FormGroup>{' '}
            <FormGroup>
              <PrintButtons
                onPrintTable={this.onPrintClick.bind(this)}
                onExportExcel={this.onExportExcel.bind(this)}
                marginLeft='0'
                width='auto'
              />
            </FormGroup>
            <FormGroup className='float-right'>
              <Button 
                bsStyle={'link'} 
                className='text-large'
                onClick={()=>{this.setState({showFilter:true})}}
              >
                <FontAwesome name='gear' />
              </Button>
            </FormGroup>  
          </Form>
    )
  }

  renderRowData() {
    let { emList, visible_fields } = this.state
    if (emList.length===0) {
      return(<tr><td colSpan={visible_fields.indexOf('dob_day')!==-1?visible_fields.length-2:visible_fields.length}>{this.props.messages['No Data']}</td></tr>)
    } else {
      return emList.map((item, index) => (
        <tr key={index} onClick={this.onRowClick.bind(this, item.employee_id)}>
          {visible_fields.map((sitem,sindex)=>
            sitem==='dob_month'||sitem==='dob_year'?''
            :sitem==='dob_day'?<td key={sindex}>{item[sitem]+(item[sitem]!==''&&item.dob_month!==''&&item.dob_year!==''?'/':'')+item.dob_month+(item[sitem]!==''&&item.dob_month!==''&&item.dob_year!==''?'/':'')+item.dob_year}</td>
            :<td key={sindex}>{item[sitem]}</td>
          )}
        </tr>
      ))
    }
  }

  renderTable() {
    let {visible_fields,sort} = this.state
    return(
        <div className='table-responsive'>
          <table id={this.refTableId} className='table table-hover table-bordered-solid' style={{marginBottom:'0',minWidth:'1280px'}}>
            <thead>
              <tr>
                {visible_fields.map((item,index)=>
                item==='employee_id'?<th key={index} onClick={this.onSortClick.bind(this,item)}>{this.getTitle(item)}&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus===''?'sort':sort.sortStatus==='asc'?'sort-asc':sort.sortStatus==='desc'?'sort-desc':'sort')} /></th>
                :item==='first_name'?<th key={index} onClick={this.onSortClick.bind(this,item)}>{this.getTitle(item)}&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus2===''?'sort':sort.sortStatus2==='asc'?'sort-asc':sort.sortStatus2==='desc'?'sort-desc':'sort')} /></th>
                :item==='last_name'?<th key={index} onClick={this.onSortClick.bind(this,item)}>{this.getTitle(item)}&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus3===''?'sort':sort.sortStatus3==='asc'?'sort-asc':sort.sortStatus3==='desc'?'sort-desc':'sort')} /></th>
                :item==='nick_name'?<th key={index} onClick={this.onSortClick.bind(this,item)}>{this.getTitle(item)}&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus4===''?'sort':sort.sortStatus4==='asc'?'sort-asc':sort.sortStatus4==='desc'?'sort-desc':'sort')} /></th>
                :item==='dob_month'||item==='dob_year'?''
                :<th key={index}>{this.getTitle(item)}</th>
                )}
              </tr>
            </thead>
            <tbody>
              {this.renderRowData()}
            </tbody>
            <tfoot>
              <tr>
                {visible_fields.map((item,index)=>
                item==='employee_id'?<th key={index} onClick={this.onSortClick.bind(this,item)}>{this.getTitle(item)}&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus===''?'sort':sort.sortStatus==='asc'?'sort-asc':sort.sortStatus==='desc'?'sort-desc':'sort')} /></th>
                :item==='first_name'?<th key={index} onClick={this.onSortClick.bind(this,item)}>{this.getTitle(item)}&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus2===''?'sort':sort.sortStatus2==='asc'?'sort-asc':sort.sortStatus2==='desc'?'sort-desc':'sort')} /></th>
                :item==='last_name'?<th key={index} onClick={this.onSortClick.bind(this,item)}>{this.getTitle(item)}&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus3===''?'sort':sort.sortStatus3==='asc'?'sort-asc':sort.sortStatus3==='desc'?'sort-desc':'sort')} /></th>
                :item==='nick_name'?<th key={index} onClick={this.onSortClick.bind(this,item)}>{this.getTitle(item)}&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus4===''?'sort':sort.sortStatus4==='asc'?'sort-asc':sort.sortStatus4==='desc'?'sort-desc':'sort')} /></th>
                :item==='dob_month'||item==='dob_year'?''
                :<th key={index}>{this.getTitle(item)}</th>
                )}
              </tr> 
            </tfoot>
          </table>
        </div>
    )
  }

  onSortClick(key,e) {
    let {emList,sort} = this.state
    if (emList!==undefined&&emList.length>1) {
      if (key==='employee_id') { 
        if (sort.sortStatus===''||sort.sortStatus==='desc') {
          sort.sortStatus = 'asc'
          emList.sort()
        } else if (sort.sortStatus==='asc') {
          sort.sortStatus = 'desc'
          emList.reverse()
        }
        sort.sortStatus2 = ''
        sort.sortStatus3 = ''
        sort.sortStatus4 = ''
      } else if (key==='first_name') { 
        if (sort.sortStatus2===''||sort.sortStatus2==='desc') {
          sort.sortStatus2 = 'asc'
          emList.sort(function(a, b) {
            if(a['first_name'] < b['first_name']) return -1;
            if(a['first_name'] > b['first_name']) return 1;
            return 0;
          })
        } else if (sort.sortStatus2==='asc') {
          sort.sortStatus2 = 'desc'
          emList.reverse(function(a, b) {
            if(a['first_name'] < b['first_name']) return -1;
            if(a['first_name'] > b['first_name']) return 1;
            return 0;
          })
        }
        sort.sortStatus = ''
        sort.sortStatus3 = ''
        sort.sortStatus4 = ''
      } else if (key==='last_name') { 
        if (sort.sortStatus3===''||sort.sortStatus3==='desc') {
          sort.sortStatus3 = 'asc'
          emList.sort(function(a, b) {
            if(a['last_name'] < b['last_name']) return -1;
            if(a['last_name'] > b['last_name']) return 1;
            return 0;
          })
        } else if (sort.sortStatus3==='asc') {
          sort.sortStatus3 = 'desc'
          emList.reverse(function(a, b) {
            if(a['last_name'] < b['last_name']) return -1;
            if(a['last_name'] > b['last_name']) return 1;
            return 0;
          })
        }
        sort.sortStatus = ''
        sort.sortStatus2 = ''
        sort.sortStatus4 = ''
      } else if (key==='nick_name') { 
        if (sort.sortStatus4===''||sort.sortStatus4==='desc') {
          sort.sortStatus4 = 'asc'
          emList.sort(function(a, b) {
            if(a['nick_name'] < b['nick_name']) return -1;
            if(a['nick_name'] > b['nick_name']) return 1;
            return 0;
          })
        } else if (sort.sortStatus4==='asc') {
          sort.sortStatus4 = 'desc'
          emList.reverse(function(a, b) {
            if(a['nick_name'] < b['nick_name']) return -1;
            if(a['nick_name'] > b['nick_name']) return 1;
            return 0;
          })
        }
        sort.sortStatus = ''
        sort.sortStatus2 = ''
        sort.sortStatus3 = ''
      }
      let reportEmConfig = {sortStatus:sort.sortStatus,sortStatus2:sort.sortStatus2,sortStatus3:sort.sortStatus3,sortStatus4:sort.sortStatus4}
      localStorage.setItem(localStorageKey, JSON.stringify(reportEmConfig))
      this.setState({emList:emList,sort:sort})
    }  
  }

  renderPaging() {
    let {messages} = this.props
    return (
      <Row>
        <Col md={12} >
          <ReactPaginate
            previousLabel={messages['Previous']}
            nextLabel={messages['Next']}
            breakLabel={<a href="">...</a>}
            breakClassName={"break-me"}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={2}
            onPageChange={this.onPageChange.bind(this)}
            containerClassName={"pagination pull-right"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"} />

        </Col>
      </Row>

    )
  }

  onMobileRowClick(item,items) {
    this.onRowClick(items[0])
  }

  onAfterEmployeeFilterSaveClick() {
    this.setState({showFilter:false})
    this.loadEmployee('work')
  }

  renderMobileTable(){
    let {emList} = this.state
    let fieldMap = {title:1,amount:0,sub_title:3,date:'',status:5,sub_status:''}
    return(
      <div>
        <ReportMobileTable
          itemlist={emList}
          fieldMap={fieldMap}
          keyIndex={0}
          numberFormat={false}
          onRowClick={this.onMobileRowClick.bind(this)}
        />
      </div>
    )
  }

  render() {
    let {isMobile,messages} = this.props
    let title = messages['All Employee Table']
    return (
      <div>
        <Box loading={this.state.loading}>
          <Box.Header border={true}>
            <Box.Title><FontAwesome name='user' />{' '}{title}</Box.Title>
            <Box.Tools>
              <Button bsStyle={'link'} className='btn-box-tool text-large'
                onClick={this.onNewEmployeeClick.bind(this)}
              >
                <FontAwesome name='plus' />&nbsp;{messages['Add New Employee']}
              </Button>
            </Box.Tools>
          </Box.Header>
          <Box.Body>
            {this.renderToolbar()}
            {isMobile?this.renderMobileTable():this.renderTable()}
            {this.renderPaging()}
          </Box.Body>
        </Box>
        <IframeModal ref='iframe' title={messages['Print Document']} />  
        <EmployeeFilterTableSettingModal
          show={this.state.showFilter}
          onHide={()=>{this.setState({showFilter:false})}}
          onAfterSave={this.onAfterEmployeeFilterSaveClick.bind(this)}
        />
      </div>
    )
  }
}

ReportEmployee.defaultProps = {
  
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
})

export default connect(
  (state) => ({messages: state.message.view.hr.report.ReportEmployee}),null,null,{withRef:true},
  mapSizesToProps
)(ReportEmployee);





// WEBPACK FOOTER //
// ./src/view/hr/report/ReportEmployee.js